import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const CopyPageTreeDialog: LoadableType<{
	contentId: string;
	onClose: () => Promise<any>;
	spaceKey: string;
}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-CopyPageTreeContainer" */ './CopyPageTreeContainer.tsx'
			)
		).CopyPageTreeContainer,
});
